export function createDetaliPageConRoomState(BuffElectrocardiogramQRST, BuffElectrocardiogramPR) {
	return {
		getFallLongTimeData: '',
		OutBeddisabled: false,
		isOutBed: 0,
		role: 2,
		heartBPM: '--',
		breathBPM: '--',
		switchStatus: true,
		isShowGray: 2,
		duration: '',
		breathXdata: [],
		breathYdata: [],
		breathYdataCopy: [],
		breathInterval: null,
		heartXdata: [],
		heartYdata: [],
		heartYdataCopy: [],
		heartInterval: null,
		replaceArr: [],
		circlePosition: '0%',
		circleTopPosition: '0px',
		circleBackground: '#53c31b',
		breathPosition: '0%',
		heartPosition: '0%',
		isShowRedHeart: 2,
		isShowRedBreath: 2,
		roomStatus: 1,
		isShowEchars: false,
		num: 10,
		intervalPulsSecond: null,
		monitorStatusStr: '',
		beginColor: '#DA9D0B',
		endColor: '#65E332',
		showEchars: false,
		leaveBedInterval: null,

		Buff_BreathWave_Y_Flt: [0, 0, 0, 0, 0],
		Phi: 0,
		BreathWave_A: 5,
		Buff_Electrocardiogram_QRST: BuffElectrocardiogramQRST,
		Buff_Electrocardiogram_PR: BuffElectrocardiogramPR,
		HeartWave_QRSTPR_cnt: 66,
		T_cnt_present: 0,
		pointer: 0,
		HeartWave_Y_Mode: [0],
		Counter: 5,
		CounterInterval: null,
		drawInterval: null,
		myChartHeart: null,
		myChartBreath: null,
		changeHeartDataInterval: null,
		heartAllLineData: [],
		isBeginDrawechars: false,
		bedSetId: '',
		radarId: '',
		editHandleTimeValOutBed: '',
		editAbnormalTimePopupOutBed: false,
		relateWC_treeData: [],
		relateWC_treeData_value: [],
		relateWC_treeData_value_Sel_Prev: [],
		relateWC_treeData_value_Sel_Next: [],

		stompClient: null,
		timer: null,
		start1: null,

		statusStompClient: null,
		statusTimer: null,
		start2: null,

		createDataInterval: null,
		createDataIntervalCount: 0,
		durationTimer: null,
		websocketData: null,
		sockFlagNum: 0,
		breathBpm: '--',
		breathDatas: [],
		paintBreathDatas: [],
		paintBreathDatasCurrentIndex: 0,
		heartBpm: '--',
		heartDatas: [],
		paintHeartDatas: [],
		paintHeartDatasCurrentIndex: 0,

		chart1: null,
		chart2: null,

		showImageName1: '',
		showImageName2: '',
		showImageName3: '',
		showImageName4: '',
		showImageName5: '',
		showText: '',
		showTextColor: '',
		statusName: '',
		stableNum: '',
		isShowStableNum: false,
		breatheColor: '#1890ff',
		breatheImageName: 'icon_alarm_detail_state_6.png',
		showBreatheBpm: '-',
		heartColor: '#53c31b',
		heartImageName: 'icon_alarm_detail_state_1.png',
		showHeartBpm: '-',
		progressArr: [],
		maxWidth: 500,

		tempSwitchState: true,
		alarmModel: null,
		isShowTipAlertWqsn: false,
		compareOldTimePeriods: null,
	};
}
